import React from 'react';
import MobileHeader from './MobileHeader';
import MobileFooter from './MobileFooter';

const MobileLayout = ({ children }) => {
  return (
    <div>
      <MobileHeader/>
      <main>{children}</main>
      <MobileFooter/>
    </div>);};

export default MobileLayout;
